import { render, staticRenderFns } from "./TranProgramActivityReminderUpdate.vue?vue&type=template&id=fe22c7a2&scoped=true"
import script from "./TranProgramActivityReminderUpdate.vue?vue&type=script&lang=js"
export * from "./TranProgramActivityReminderUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranProgramActivityReminderUpdate.vue?vue&type=style&index=0&id=fe22c7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe22c7a2",
  null
  
)

export default component.exports